<template>
  <div class="emotionChartContainer">
    <div :ref="id+'-emotionChart'" class="emotionChart">{{pieData}}</div>
  </div>
</template>
<script>
export default {
  props: {
    pieData: {
      require: true,
    },
    id: {
      required: true,
    }
  },
  data () {
    return {
      chartContianer: null
    }
  },
  watch: {
    pieData: {
      immediate: true,
      deep: true,
      handler () {
        this.$nextTick(() => {
          this.initData()
        })
      }
    }
  },
  methods: {
    initData: function () {
      this.chartContianer = this.$echarts.init(this.$refs[this.id + '-emotionChart'])
      this.chartContianer.clear()
      let option = {
        color: ['#7ECB82', '#FFC66E', '#FF646A'],
        title: {
          text: '对话情绪分析',
          left: 'center',
          top: 5,
          textStyle: {
            fontSize: 14
          }
        },
        grid: {
          borderWidth: 1,
          containLabel: true,
        },
        tooltip: {
          trigger: 'item',
          confine: true
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 0,
          top: 'middle',
          itemWidth: 15,
          itemHeight: 10,
        },
        series: [
          {
            name: '对话情绪分析',
            type: 'pie',
            radius: '65%',
            center: ['60%', '60%'],
            data: this.pieData || [],
            labelLine: {
              show: false
            },
            label: {
              show: false
            }
          }
        ]
      }
      this.chartContianer.setOption(option)
    },
    rs: function () {
      if (this.chartContianer) this.chartContianer.resize()
    }
  },
  beforeMount () {
    window.addEventListener('resize', () => { this.rs() })
  },
  beforeDestroy () {
    window.removeEventListener("resize", () => { })
  }
}
</script>
<style lang="less" scoped>
.emotionChartContainer {
  border: 2px dashed #2575ed;
  border-radius: 3px;
  // overflow: hidden;
  width: 100%;
  margin: 10px 0;

  .emotionChart {
    margin: 10px 0;
    height: 140px;
  }
}
</style>